import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';
import type { Resource } from '../hooks/api/useResources';

interface CrisisModalContextProps {
  isOpen: boolean;
  emergency: boolean;
  selfHarm: boolean;
  crisisResource?: Resource;
  openCrisisModal: (options?: { emergency?: boolean; selfHarm?: boolean; crisisResource?: Resource }) => void;
  closeCrisisModal: () => void;
}

const CrisisModalContext = createContext<CrisisModalContextProps | undefined>(undefined);

export const CrisisModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [emergency, setEmergency] = useState(false);
  const [selfHarm, setSelfHarm] = useState(false);
  const [crisisResource, setCrisisResource] = useState<Resource | undefined>();

  const openCrisisModal = useCallback(
    (options?: { emergency?: boolean; selfHarm?: boolean; crisisResource?: Resource }) => {
      setEmergency(options?.emergency ?? false);
      setSelfHarm(options?.selfHarm ?? false);
      setCrisisResource(options?.crisisResource);
      setIsOpen(true);
    },
    [],
  );

  const closeCrisisModal = useCallback(() => {
    setIsOpen(false);
    setCrisisResource(undefined);
  }, []);

  return (
    <CrisisModalContext.Provider
      value={{ isOpen, emergency, selfHarm, crisisResource, openCrisisModal, closeCrisisModal }}
    >
      {children}
    </CrisisModalContext.Provider>
  );
};

export const useCrisisModal = () => {
  const context = useContext(CrisisModalContext);
  if (!context) {
    throw new Error('useCrisisModal must be used within a CrisisModalProvider');
  }
  return context;
};
